//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ObjectSnippet from '@/components/objects/ObjectSnippet.vue'
import UserPublicAvatar from '@/components/users/UserPublicAvatar.vue'
import UserProfileCommentItem from '@/components/users/UserProfileCommentItem.vue'
import Subscribes from '@/components/objects/public/Subscribes.vue'
import { STORAGE_IMAGE_PATH } from '@/constants/ui.js'
import { formatAuthorContribution, userDisplayName } from '@/utils/userPublic.js'

const PER_PAGE = 12

function tabLabel(title, count) {
  return count > 0 ? `${title} (${count})` : title
}

export default {
  name: 'UserPublicProfile',
  components: { UserPublicAvatar, UserProfileCommentItem, ObjectSnippet, Subscribes },
  layout: 'public_new',
  async asyncData({ store, params, error }) {
    const authorId = params.id
    let author = null
    try {
      author = await store.dispatch('users/fetchPublicProfile', authorId)
    } catch (e) {
      error({ statusCode: 404, message: 'Пользователь не найден' })
      return
    }

    const authorStats = await store
      .dispatch('users/fetchPublicAuthorStats', authorId)
      .catch(() => null)

    const articlesTotal = authorStats?.articles_total ?? null
    const encyclopediaTotal = authorStats?.encyclopedia_total ?? null
    const commentsTotal = authorStats?.comments_total ?? null

    const loadArticles = articlesTotal === null || articlesTotal > 0
    const loadEncyclopedia = encyclopediaTotal === null || encyclopediaTotal > 0
    const loadComments = commentsTotal === null || commentsTotal > 0

    const fetches = [
      store.dispatch('art/fetchMaterialCategories').catch(() => {}),
    ]

    if (loadArticles) {
      fetches.push(
        store.dispatch('art/publicObjectsByAuthor', {
          user: authorId,
          limit: PER_PAGE,
          offset: 0,
          order: '-total_score',
        }).catch(() => ({ items: [], total: 0 }))
      )
    } else {
      fetches.push(Promise.resolve({ items: [], total: 0 }))
    }

    if (loadEncyclopedia) {
      fetches.push(
        store.dispatch('objects/publicObjectsByAuthor', {
          user: authorId,
          limit: PER_PAGE,
          offset: 0,
          order: '-total_score',
        }).catch(() => ({ items: [], total: 0 }))
      )
    } else {
      fetches.push(Promise.resolve({ items: [], total: 0 }))
    }

    if (loadComments) {
      fetches.push(
        store.dispatch('art/publicUserComments', { id: authorId }).catch(() => [])
      )
    } else {
      fetches.push(Promise.resolve([]))
    }

    const [, articlesRes, encyclopediaRes, comments] = await Promise.all(fetches)

    const resolvedArticlesTotal = articlesTotal ?? articlesRes?.total ?? 0
    const resolvedEncyclopediaTotal = encyclopediaTotal ?? encyclopediaRes?.total ?? 0
    const resolvedCommentsTotal = commentsTotal ?? comments?.length ?? 0

    const activeTabKey = resolvedArticlesTotal > 0
      ? 'articles'
      : resolvedEncyclopediaTotal > 0
        ? 'encyclopedia'
        : resolvedCommentsTotal > 0
          ? 'comments'
          : 'articles'

    return {
      author,
      authorId,
      authorStats,
      articles: articlesRes.items || [],
      encyclopedia: encyclopediaRes.items || [],
      articlesTotal: resolvedArticlesTotal,
      encyclopediaTotal: resolvedEncyclopediaTotal,
      commentsTotal: resolvedCommentsTotal,
      articlesPage: 0,
      encyclopediaPage: 0,
      articlesPerPage: PER_PAGE,
      encyclopediaPerPage: PER_PAGE,
      activeTabKey,
      materialCategories: store.state.art.materialCategories || [],
      articleImagePath: [`${STORAGE_IMAGE_PATH}$id`, 'cover'],
      comments: Array.isArray(comments) ? comments : [],
    }
  },
  data() {
    return {
      author: null,
      authorId: null,
      authorStats: null,
      comments: [],
      currentCategory: {},
      articles: [],
      encyclopedia: [],
      articlesTotal: 0,
      encyclopediaTotal: 0,
      commentsTotal: 0,
      articlesPage: 0,
      encyclopediaPage: 0,
      articlesPerPage: PER_PAGE,
      encyclopediaPerPage: PER_PAGE,
      activeTabKey: 'articles',
      materialCategories: [],
      articleImagePath: [],
      pageLoading: false,
    }
  },
  head() {
    const name = userDisplayName(this.author) || 'Автор'
    return {
      title: `${name} — автор ViStat`,
    }
  },
  computed: {
    displayName() {
      return userDisplayName(this.author)
    },
    contributionText() {
      if (this.authorStats?.materials_total != null) {
        return formatAuthorContribution(this.authorStats.materials_total)
      }
      const total = this.articlesTotal + this.encyclopediaTotal
      return formatAuthorContribution(total)
    },
    commentsCount() {
      return this.commentsTotal ?? this.comments.length
    },
    hasSocials() {
      const p = this.author?.profile
      return Boolean(
        p?.telegram_url || p?.vk_url || p?.whatsapp_url || p?.phone || (Array.isArray(p?.urls) && p.urls.length)
      )
    },
    profileAssetLink() {
      const asset = this.author?.profile?.asset
      if (!asset || typeof asset !== 'object') return null
      const slug = asset.vistat_slug ?? asset.vistat_id ?? asset.id
      if (slug == null) return null
      return (asset.vistat_kind || asset.type) === 'art' ? `/art/${slug}` : `/objects/${slug}`
    },
    showArticlesTab() {
      return this.articlesTotal > 0
    },
    showEncyclopediaTab() {
      return this.encyclopediaTotal > 0
    },
    showCommentsTab() {
      return this.commentsTotal > 0 || this.comments.length > 0
    },
    hasTabs() {
      return this.showArticlesTab || this.showEncyclopediaTab || this.showCommentsTab
    },
    articlesTabLabel() {
      return tabLabel('Статьи', this.articlesTotal)
    },
    encyclopediaTabLabel() {
      return tabLabel('Энциклопедия', this.encyclopediaTotal)
    },
    commentsTabLabel() {
      return tabLabel('Комментарии', this.commentsCount)
    },
    articlesHasMore() {
      return this.articles.length >= this.articlesPerPage
        && (this.articlesTotal == null || this.articles.length < this.articlesTotal)
    },
    encyclopediaHasMore() {
      return this.encyclopedia.length >= this.encyclopediaPerPage
        && (this.encyclopediaTotal == null || this.encyclopedia.length < this.encyclopediaTotal)
    },
    sortedComments() {
      return [...this.comments].sort((a, b) => {
        const dateA = this.getCommentCreatedAt(a)
        const dateB = this.getCommentCreatedAt(b)
        return Date.parse(dateB) - Date.parse(dateA)
      })
    },
  },
  methods: {
    getCommentNode(item) {
      return item?.node ?? item ?? {}
    },
    getCommentCreatedAt(item) {
      const node = this.getCommentNode(item)
      return node.created_at ?? item?.created_at ?? 0
    },
    getCommentId(item) {
      const node = this.getCommentNode(item)
      return node.id ?? item?.id
    },
    getCommentMaterial(item) {
      const node = this.getCommentNode(item)
      return item?.obj_annotated
        ?? node?.obj_annotated
        ?? item?.material_annotated
        ?? item?.material
        ?? item?.object_annotated
        ?? null
    },
    getCommentMaterialRoute(item) {
      const material = this.getCommentMaterial(item)
      const slug = material?.slug
      if (!slug) return null

      const objCls = item?.obj_cls ?? this.getCommentNode(item)?.obj_cls
      if (objCls === 'objects') {
        return {
          name: 'objects-slug',
          params: { slug },
          hash: '#comments',
        }
      }

      return {
        name: material.is_spec_project ? 'sp-slug' : 'art-slug',
        params: { slug },
        hash: '#comments',
      }
    },
    loadMoreArticles($state) {
      this.articlesPage += 1
      this.$store
        .dispatch('art/publicObjectsByAuthor', {
          user: this.authorId,
          limit: this.articlesPerPage,
          offset: this.articlesPage * this.articlesPerPage,
          order: '-total_score',
        })
        .then((response) => {
          if (response.items?.length) {
            this.articles.push(...response.items)
            $state.loaded()
          } else {
            $state.complete()
          }
        })
        .catch(() => $state.complete())
    },
    loadMoreEncyclopedia($state) {
      this.encyclopediaPage += 1
      this.$store
        .dispatch('objects/publicObjectsByAuthor', {
          user: this.authorId,
          limit: this.encyclopediaPerPage,
          offset: this.encyclopediaPage * this.encyclopediaPerPage,
          order: '-total_score',
        })
        .then((response) => {
          if (response.items?.length) {
            this.encyclopedia.push(...response.items)
            $state.loaded()
          } else {
            $state.complete()
          }
        })
        .catch(() => $state.complete())
    },
  },
}
